//Componentes generales
import React, { useState, useMemo, useContext } from "react";
import { FixedSizeList } from "react-window";
import SearchInput from "../searchInput/SearchInput";
import RenderRow from "../renderRows/RRSubcuentas";
import windowSizeContext from "../../context/windowSize/windowSizeContext";

//Estilos
import "./SubcuentaList.css";

/*
    Componente encargado de la vista de las subcuentas disponibles.
    Donde subcuentas es la lista de subcuentas disponibles recuperados del context.
*/
function SubcuentaList({ subcuentas = [] }) {
  //state de filtro.
  const [filter, setFilter] = useState("");

  // Calcula el valor del height según el tamaño de la pantalla y el tamaño del navbar
  const wSContext = useContext(windowSizeContext);
  let { height } = wSContext;

  /*
    Manejador ante cambios en filtro.
    Donde data es el texto ingresado por el usuario.
    */
  const handdlerSearchInput = (data) => {
    setFilter(data);
  };

  return (
    <div>
      <div style={{ marginLeft: "-350px" }}>
        <SearchInput defaultValue={filter} buscar={handdlerSearchInput} />
      </div>
      <div className="container-subcuenta-list">
      
        <FixedSizeList
          height={height - 270}
          itemCount={
            filter === ""
              ? subcuentas.length
              : subcuentas.filter(
                (s) =>
                  s.codDim.toLowerCase().includes(filter.toLowerCase()) ||
                  s.codDimDescrp.toLowerCase().includes(filter.toLowerCase()) ||
                  s.subCue.toLowerCase().includes(filter.toLowerCase()) ||
                  s.subCueDescrp.toLowerCase().includes(filter.toLowerCase())
              ).length
          }
          itemSize={110}
          width={"100%"}
        >
          {({ index, style }) => (
            <RenderRow
              index={index}
              style={style}
              subcuentas={subcuentas}
              filter={filter}
            />
          )}
        </FixedSizeList>
      </div>
    </div>
  );
}

export default SubcuentaList;